module.exports = __webpack_public_path__ + "assets/img/DS-master (1).f872cb12.jpg";